import { useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import "./css/layout.css";
import { IoBarChart, IoCash, IoChevronDown, IoCube, IoHeadset, IoNotifications, IoPersonAdd, IoPricetag, IoSettings, IoStar, IoTrendingUp } from "../../components/icons";

const Sidebar = ({ isOpen, closeSidebar }) => {
  const location = useLocation();
  const [isCustomerServiceOpen, setIsCustomerServiceOpen] = useState(false);
  const [isStaticOpen, setIsStaticOpen] = useState(false);
  const [isCustOpen, setIsCustOpen] = useState(false);
  const [isProductOpen, setIsProductOpen] = useState(false);
  const [isAlarmOpen, setIsAlarmOpen] = useState(false);
  const [isSystemOpen, setIsSystemOpen] = useState(false);

  const menuAuth = useMemo(() => {
    try {
      const admin = JSON.parse(localStorage.getItem("admin"));
      return admin?.menuAuth || [];
    } catch (error) {
      console.error("Failed to parse admin from localStorage:", error);
      return [];
    }
  }, []);

  const hasPermission = (code) => {
    return menuAuth.includes(code);
  };

  const handleLinkClick = () => {
    if (window.innerWidth < 992) {
      closeSidebar();
    }
  };

  return (
    <div
      id="admin-layoutSidenav_nav"
      className={isOpen ? "admin-sidebar-visible" : ""}
    >
      <nav
        className="admin-sb-sidenav accordion admin-sb-sidenav-dark"
        id="sidenavAccordion"
      >
        <div className="admin-side-logo">
          <a className="navbar-brand" href="/admin">
            <img
              src="/images/logo_v2_white.png"
              alt="logo"
              className="admin-logo"
            />
          </a>
        </div>
        <div className="admin-sb-sidenav-menu">
          <div className="nav">
            {/* 회원관리 */}
            {hasPermission("ADMIN_ACCOUNT") && (
              <>
                <div className="admin-sb-sidenav-menu-heading">회원</div>
                <a
                  className={`nav-link ${isCustOpen ? "active" : "collapsed"}`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsCustOpen(!isCustOpen);
                  }}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoBarChart color="white"/>
                  </div>
                  회원관리
                  <div className="admin-sb-sidenav-collapse-arrow">
                    <IoChevronDown />
                  </div>
                </a>
                <div className={`collapse ${isCustOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link
                      className="nav-link"
                      to="/admin/cust"
                      onClick={handleLinkClick}
                    >
                      일반
                    </Link>
                    <Link
                      className="nav-link"
                      to="/admin/store"
                      onClick={handleLinkClick}
                    >
                      가맹
                    </Link>
                  </nav>
                </div>
                <Link
                  className="nav-link"
                  to="/admin/accept"
                  onClick={handleLinkClick}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoPersonAdd color="white"/>
                  </div>
                  가입관리
                </Link>
              </>
            )}

            {/* 상품관리 */}
            {hasPermission("ADMIN_PRODUCT") && (
              <>
                <div className="admin-sb-sidenav-menu-heading">상품</div>
                <a
                  className={`nav-link ${isProductOpen ? "active" : "collapsed"}`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsProductOpen(!isProductOpen);
                  }}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoCube color="white"/>
                  </div>
                  상품관리
                  <div className="admin-sb-sidenav-collapse-arrow">
                    <IoChevronDown />
                  </div>
                </a>
                <div className={`collapse ${isProductOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link className="nav-link" to="/admin/product" onClick={handleLinkClick}>
                      상품
                    </Link>
                  </nav>
                </div>
                <div className={`collapse ${isProductOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link className="nav-link" to="/admin/product/sale" onClick={handleLinkClick}>
                      할인
                    </Link>
                  </nav>
                </div>
                <div className={`collapse ${isProductOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link className="nav-link" to="/admin/product/nego" onClick={handleLinkClick}>
                      네고
                    </Link>
                  </nav>
                </div>
                <div className={`collapse ${isProductOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link className="nav-link" to="/admin/product/negorequest" onClick={handleLinkClick}>
                      네고 요청
                    </Link>
                  </nav>
                </div>
              </>
            )}

            {/* 통계정보 */}
            {hasPermission("ADMIN_STAT") && (
              <>
                <div className="admin-sb-sidenav-menu-heading">통계/매출</div>
                <a
                  className={`nav-link ${isStaticOpen ? "active" : "collapsed"}`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsStaticOpen(!isStaticOpen);
                  }}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoTrendingUp color="white"/>
                  </div>
                  통계/매출
                  <div className="admin-sb-sidenav-collapse-arrow">
                    <IoChevronDown />
                  </div>
                </a>
                <div className={`collapse ${isStaticOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link
                      className="nav-link"
                      to="/admin/region"
                      onClick={handleLinkClick}
                    >
                      지역 통계
                    </Link>
                  </nav>
                </div>
                <div className={`collapse ${isStaticOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link
                      className="nav-link"
                      to="/admin/order"
                      onClick={handleLinkClick}
                    >
                      매출 목록
                    </Link>
                  </nav>
                </div>
              </>
            )}

            {/* 리뷰관리 */}
            {hasPermission("ADMIN_REVIEW") && (
              <>
                <div className="admin-sb-sidenav-menu-heading">리뷰</div>
                <Link
                  className="nav-link"
                  to="/admin/review"
                  onClick={handleLinkClick}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoStar color="white"/>
                  </div>
                  리뷰관리
                </Link>
              </>
            )}

            {/* 알림/푸시정보 */}
            {hasPermission("ADMIN_NOTIFICATION") && (
              <>
                <div className="admin-sb-sidenav-menu-heading">알림/푸시</div>
                <a
                  className={`nav-link ${isAlarmOpen ? "active" : "collapsed"}`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsAlarmOpen(!isAlarmOpen);
                  }}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoNotifications color="white"/>
                  </div>
                  알림/푸시정보
                  <div className="admin-sb-sidenav-collapse-arrow">
                    <IoChevronDown />
                  </div>
                </a>
                <div className={`collapse ${isAlarmOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link
                      className="nav-link"
                      to="/admin/alarm"
                      onClick={handleLinkClick}
                    >
                      알림
                    </Link>
                    <Link
                      className="nav-link"
                      to="/admin/push"
                      onClick={handleLinkClick}
                    >
                      앱푸시
                    </Link>
                  </nav>
                </div>
              </>
            )}

            {/* 고객센터 */}
            {hasPermission("ADMIN_CS") && (
              <>
                <div className="admin-sb-sidenav-menu-heading">고객센터</div>
                <a
                  className={`nav-link ${isCustomerServiceOpen ? "active" : "collapsed"}`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsCustomerServiceOpen(!isCustomerServiceOpen);
                  }}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoHeadset color="white"/>
                  </div>
                  고객센터
                  <div className="admin-sb-sidenav-collapse-arrow">
                    <IoChevronDown />
                  </div>
                </a>
                <div
                  className={`collapse ${isCustomerServiceOpen ? "show" : ""}`}
                >
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    <Link
                      className="nav-link"
                      to="/admin/notice"
                      onClick={handleLinkClick}
                    >
                      공지사항
                    </Link>
                    <Link
                      className="nav-link"
                      to="/admin/question"
                      onClick={handleLinkClick}
                    >
                      문의/신고
                    </Link>
                    <Link
                      className="nav-link"
                      to="/admin/faq"
                      onClick={handleLinkClick}
                    >
                      FAQ
                    </Link>
                  </nav>
                </div>
              </>
            )}

            {/* 시스템관리 */}
            {(hasPermission("ADMIN_SYSTEM") ||
              hasPermission("ADMIN_CATEGORY") ||
              hasPermission("ADMIN_EMPLOYEE")) && (
              <>
                <div className="admin-sb-sidenav-menu-heading">시스템관리</div>
                <a
                  className={`nav-link ${isSystemOpen ? "active" : "collapsed"}`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSystemOpen(!isSystemOpen);
                  }}
                >
                  <div className="admin-sb-nav-link-icon">
                    <IoSettings color="white"/>
                  </div>
                  시스템관리
                  <div className="admin-sb-sidenav-collapse-arrow">
                    <IoChevronDown />
                  </div>
                </a>
                <div className={`collapse ${isSystemOpen ? "show" : ""}`}>
                  <nav className="admin-sb-sidenav-menu-nested nav">
                    {hasPermission("ADMIN_SYSTEM") && (
                      <Link
                        className="nav-link"
                        to="/admin/authmanage"
                        onClick={handleLinkClick}
                      >
                        권한관리
                      </Link>
                    )}
                    {hasPermission("ADMIN_CATEGORY") && (
                      <Link
                        className="nav-link"
                        to="/admin/categorymanage"
                        onClick={handleLinkClick}
                      >
                        카테고리관리
                      </Link>
                    )}
                    {hasPermission("ADMIN_EMPLOYEE") && (
                      <Link
                        className="nav-link"
                        to="/admin/emp"
                        onClick={handleLinkClick}
                      >
                        사용자관리
                      </Link>
                    )}
                  </nav>
                </div>
              </>
            )}

            {/* 정산관리 */}
            {(hasPermission("ADMIN_PAYOUT") ||
              hasPermission("ADMIN_PAYMENT_FEE")) && (
              <>
                <div className="admin-sb-sidenav-menu-heading">정산</div>
                {hasPermission("ADMIN_PAYOUT") && (
                  <Link
                    className={`nav-link ${
                      location.pathname === "/admin/payout" ? "active" : ""
                    }`}
                    to="/admin/payout"
                    onClick={handleLinkClick}
                  >
                    <div className="admin-sb-nav-link-icon">
                      <IoCash color="white"/>
                    </div>
                    정산관리
                  </Link>
                )}
                {hasPermission("ADMIN_PAYMENT_FEE") && (
                  <Link
                    className={`nav-link ${
                      location.pathname === "/admin/payout/fee"
                        ? "active"
                        : ""
                    }`}
                    to="/admin/payout/fee"
                    onClick={handleLinkClick}
                  >
                    <div className="admin-sb-nav-link-icon">
                      <IoPricetag color="white" />
                    </div>
                    수수료 설정
                  </Link>
                )}
              </>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
